import styled, { css } from 'styled-components';
import { TextLabel } from '../TextLabel';

const StyledContainer = styled.div<{ $online?: boolean; $favorite?: boolean }>`
	position: relative;
	width: 290px;
	height: 90px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 20px;
	background-color: ${(props) =>
		props.$favorite
			? 'rgba(250,190,44,0.1)'
			: props.$online
			? 'rgba(255,255,255,0.05)'
			: 'rgba(255,255,255,0.02)'};
	border-radius: 10px;
`;

const StyledLeftContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledNameOnlineContainer = styled.div<{ $online?: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 3px;

	${TextLabel} {
		color: #ffffff;

		&.name {
			font-weight: 500;
			font-size: 12px;
		}

		&.online {
			font-size: 10px;
			color: ${(props) =>
				props.$online ? '#77DE38' : 'rgba(255,255,255,0.25)'};
		}
	}
`;

const StyledImage = styled.img<{ $online?: boolean }>`
	width: 40px;
	height: 40px;
	border-radius: 40px;

	${(props) =>
		props.$online
			? css`
					padding: 2px;
					border: 2px solid #77de38;
			  `
			: css`
					filter: grayscale(1);
			  `}
`;

const StyledButtonsContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
`;

const StyledImageButton = styled.img<{ $active?: boolean }>`
	user-select: none;
	opacity: ${(props) => (props.$active ? 1 : 0.5)};
	transition: opacity 0.3s ease;
	object-fit: contain;
	cursor: pointer;

	&:hover {
		opacity: 1;
	}
`;

const StyledDropdownWrapper = styled.div<{
	$right?: boolean;
	$bottom?: boolean;
}>`
	position: absolute;
	right: ${(props) => (props.$right ? 0 : -100)}px;
	${(props) =>
		props.$bottom
			? css`
					bottom: 60px;
			  `
			: css`
					top: 60px;
			  `}
	z-index: 10;
	opacity: 0;
	transition: opacity 0.3s ease;

	&.menu-enter {
		opacity: 0;
	}

	&.menu-enter-active,
	&.menu-enter-done,
	&.menu-exit {
		opacity: 1;
	}

	&.menu-exit-active {
		opacity: 0;
	}
`;

export {
	StyledContainer,
	StyledLeftContainer,
	StyledImage,
	StyledNameOnlineContainer,
	StyledButtonsContainer,
	StyledImageButton,
	StyledDropdownWrapper,
};
